import Swiper, { EffectFade, Lazy, Navigation, Pagination } from "swiper";

class ImageSlider {
  wrapper = null;
  progress = null;
  totalSlides = 0;

  constructor(el) {
    this.wrapper = $(el);

    if ( this.wrapper.length ) {
      this.init();
    }
  }

  init() {
    const self = this;
    this.progress = this.wrapper.find(".image-slider__progress");
    this.totalSlides = this.wrapper.find('.swiper-slide').length;

    this.handleProgress(0);

    new Swiper(this.wrapper.children('.swiper')[0], {
      modules: [EffectFade, Lazy, Navigation, Pagination],
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: this.wrapper.find(".swiper-pagination")[0],
      },
      navigation: {
        nextEl: this.wrapper.find(".swiper-nav--next")[0],
        prevEl: this.wrapper.find(".swiper-nav--prev")[0],
      },
      on: {
        slideChange: (swiper) => {
          self.handleProgress(swiper.realIndex);
        }
      }
    });
  }

  handleProgress(index) {
    index = index + 1;
    let progress = index * 100 / this.totalSlides;
    this.progress.children('span').css('width', progress + '%');
  }
}

export default ImageSlider;
